import { initialize, getInAppMessages } from "@iterable/web-sdk";

const iterableAuth = localStorage.getItem("iterableAuth");

if (process.env.ITERABLE_WEB_API_KEY && iterableAuth) {
  const token = JSON.parse(iterableAuth)?.token;
  const email = JSON.parse(iterableAuth)?.email;

  if (token && email) {
    const getToken = async () => {
      return Promise.resolve(token);
    };

    const { setEmail } = initialize(
      process.env.ITERABLE_WEB_API_KEY || "",
      getToken
    );

    const { request } = getInAppMessages(
      {
        count: 20,
        displayInterval: 1000,
        onOpenScreenReaderMessage: "...",
        onOpenNodeToTakeFocus: "input",
        closeButton: { color: '#333', position: 'top-right', sideOffset: '16px', size: '22px', topOffset: '16px' },
        packageName: "Ring Twice",
        handleLinks: "external-new-tab",
      },
      { display: "immediate" }
    );

    // Set the email address, and make the request to get the in-app messages
    // that are available for that user. Display them automatically.
    setEmail(JSON.parse(localStorage.getItem("iterableAuth")).email).then(
      async () => {
        try {
          await request();
        } catch (e) {
          console.warn("Could not get in-app messages", e);
        }
      }
    );
  }
}
